module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-5ad4edc7.png";